import { categoryAPI } from './api';
import Swal from 'sweetalert2';

export const categoryActions = {
    // Fetch all categories with filters
    fetchCategories: (filters = {}) => {
        debugger;
        return async (dispatch) => {
            try {
                const response = await categoryAPI.list(filters);
                
                if (response.status) {
                    // Only dispatch if not fetching subcategories
                    if (!filters.parent_id) {
                        dispatch({
                            type: "category_list",
                            payload: response.data.categories || response.data
                        });
                    }
                    
                    return {
                        success: true,
                        data: response.data,
                        pagination: response.pagination
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
                return {
                    success: false,
                    message: error.message || 'Failed to fetch categories'
                };
            }
        };
    },
    
    // Fetch all parent categories for dropdown
    fetchParentCategories: () => {
        debugger;
        return async () => {
            try {
                const response = await categoryAPI.getParentCategories();
                debugger;
                if (response.status) {
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error fetching parent categories:', error);
                return {
                    success: false,
                    message: error.message || 'Failed to fetch parent categories'
                };
            }
        };
    },
    
    // Fetch subcategories for a specific parent category
    fetchSubcategories: (parentId, filters = {}) => {
        debugger;
        return async (dispatch) => {
            try {
                const params = {
                    ...filters,
                    parent_id: parentId,
                    page: 1,
                    limit: 100 // Get all subcategories, adjust as needed
                };
                
                const response = await categoryAPI.list(params);
                
                if (response.status) {
                    // Dispatch subcategories to store if needed
                    dispatch({
                        type: "subcategory_list",
                        payload: {
                            parentId: parentId,
                            subcategories: response.data.categories || response.data
                        }
                    });
                    
                    return {
                        success: true,
                        data: response.data.categories || response.data,
                        parentId: parentId,
                        pagination: response.pagination
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error fetching subcategories:', error);
                return {
                    success: false,
                    message: error.message || 'Failed to fetch subcategories'
                };
            }
        };
    },
    
    // Fetch single category by ID
    fetchCategoryById: (id) => {
        debugger;
        return async (dispatch) => {
            try {
                const response = await categoryAPI.get(id);
                
                if (response.status) {
                    dispatch({
                        type: "selected_category",
                        payload: response.data
                    });
                    
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error fetching category:', error);
                return {
                    success: false,
                    message: error.message || 'Failed to fetch category'
                };
            }
        };
    },
    
    // Create category
   createCategory: (categoryData) => {
        return async () => {
            try {
                const response = await categoryAPI.create(categoryData);
                
                if (response.status) {
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error creating category:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: error.message || 'Failed to create category',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to create category'
                };
            }
        };
    },
    
    // Update category
    updateCategory: (id, categoryData) => {
        return async () => {
            try {
                const response = await categoryAPI.update(id, categoryData);
                
                if (response.status) {
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error updating category:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: error.message || 'Failed to update category',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to update category'
                };
            }
        };
    },
    
    // Delete category
 deleteCategory: (id) => {
        return async () => {
            try {
                const response = await categoryAPI.delete(id);
                debugger;
                if (response.status) {
                    return {
                        success: true
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error deleting category:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: error.message || 'Failed to delete category',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to delete category'
                };
            }
        }
    },
    
    // Note: If you need bulk import, add it here:
    /*
    bulkImportCategories: (formData) => {
        return async (dispatch) => {
            try {
                const response = await categoryAPI.bulkImport(formData);
                
                if (response.status) {
                    dispatch(categoryActions.fetchCategories());
                    
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error('Error importing categories:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Import Failed!',
                    text: error.message || 'Failed to import categories',
                    confirmButtonColor: '#ff0000'
                });
                return {
                    success: false,
                    message: error.message || 'Failed to import categories'
                };
            }
        };
    }
    */
};